/**
 * Publishes the function that opens a sidebar item on the item itself, so that the sidebar
 * can open whatever is topmost at the moment without holding a registration that has to be
 * kept in sync as the list changes.
 *
 * Call it from a reactive statement rather than on mount, since a sidebar item component is
 * reused for another item when the list around it changes:
 *
 *     $: publishOpenAction(edit, action);
 *
 * @param {Object} item The item the component presents.
 * @param {Function} action The function that opens the item.
 */
export function publishOpenAction(item, action) {
    if (!item) {
        return;
    }

    item.open = action;
}
